<template>
  <div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{text}}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <v-snackbar :top="y === 'top'" v-model="errorSnackbar">
      {{text}}
      <v-btn color="red" class="white--text" flat @click="errorSnackbar = false">X</v-btn>
    </v-snackbar>
    <v-toolbar flat color="white">
      <h2
        class="dark-grey--text px-2 pt-3"
        v-if="serviceAccount"
      >Service Account: {{serviceAccount.id}}</h2>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card flat>
      <v-container grid-list-xs>
        <v-layout wrap>
          <v-flex xs12 sm5 md5 mb-1>
            <v-card class="rounded-card">
              <v-card-text>
                <h2 class="dark-grey--text">Account Summary</h2>
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-layout justify-center>
                        <v-flex xs8 v-if="serviceAccount.serviceAccountIdentifier">
                          <h2 class="subheading grey--text font-weight-bold">Account Code:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.serviceAccountIdentifier}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="serviceAccount.initialActivation">
                        <v-flex xs8>
                          <h2
                            class="subheading grey--text font-weight-bold"
                          >Initial Activation Date:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">
                            <v-chip
                              small
                              color="primary"
                              class="white--text font-weight-bold"
                            >{{formatDate(serviceAccount.initialActivation)}}</v-chip>
                          </h3>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-left>
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Last Update:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">
                            <v-chip
                              small
                              color="primary"
                              class="white--text font-weight-bold"
                            >{{formatDate(serviceAccount.createdAt)}}</v-chip>
                          </h3>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center>
                        <v-flex xs8>
                          <h2
                            class="subheading grey--text font-weight-bold"
                          >Internet Service Provider:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <!-- <v-avatar> -->
                          <v-img contain :src="serviceAccount.customerOrganisation.logo" />
                          <!-- </v-avatar> -->
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center>
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Data Package:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3
                            class="grey--text font-weight-light"
                            v-if="serviceAccount.customerOrganisation"
                          >{{serviceAccount.customerOrganisation.name}} | {{serviceAccount.packagesIsp.name}}</h3>
                          <v-icon color="red" v-else>not_interested</v-icon>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="serviceAccount.packagesIspId!==null">
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Data Package Term:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.packagesIsp.term}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="serviceAccount.packagesIspId!==null">
                        <v-flex xs8>
                          <h2
                            class="subheading grey--text font-weight-bold"
                          >Data Package Monthly Fee:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.packagesIsp.recurringPriceVatInc|currency}}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout v-if="serviceAccount.packagesIspId!==null">
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Speed Profile (Mbps):</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">
                            <v-icon color="light-green">arrow_drop_down</v-icon>
                            {{serviceAccount.packagesIsp.packagesFno.speedProfile.downloadMbps}}
                            <v-icon color="red">arrow_drop_up</v-icon>
                            {{serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps}}
                          </h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md3 mb-1 mx-1>
            <v-card class="rounded-card" >
              <v-card-text>
                <h2 class="dark-grey--text">Account History</h2>

                <v-container grid-list-xs>
                  <v-layout wrap justify-center>
                    <v-flex
                      xs12
                      sm12
                      md12
                      v-for="history in serviceAccountHistory"
                      :key="history.id"
                      text-xs-left
                    >
                      <v-card hover class="ma-2 pa-2">
                        <v-tile wrap>
                          <v-tile-title class="grey--text">{{history.packagesIsp.name}}</v-tile-title>
                          <v-spacer></v-spacer>
                          <v-tile-title class="grey--text">
                            <b>Service Account ID:</b>
                            {{history.id}}
                          </v-tile-title>
                          <v-spacer></v-spacer>
                          <v-tile-content class="grey--text" v-if="history.fnoActivationDate">
                            <v-chip
                              dense
                              color="light-green"
                              class="white--text font-weight-bold"
                            >{{formatDate(history.fnoActivationDate)}}</v-chip>-
                            <v-chip
                              dense
                              v-if="history.fnoDeactivationDate"
                              color="red"
                              class="white--text font-weight-bold"
                            >{{formatDate(history.fnoDeactivationDate)}}</v-chip>
                            <v-chip
                              v-else
                              color="blue"
                              dense
                              class="white--text font-weight-bold"
                            >Present</v-chip>
                          </v-tile-content>
                          <v-tile-content class="grey--text" v-else>
                            <v-chip
                              dense
                              color="blue"
                              class="white--text font-weight-bold"
                            >Pending Activation</v-chip>
                           
                          </v-tile-content>
                        </v-tile>
                      </v-card>
                    </v-flex>

                    <v-flex v-if="allServiceAccountHistory.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Service Account History</h3>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 v-if="allServiceAccountHistory.length > 2" class="card-actions">
                      <v-pagination
                        v-model="serviceAccountHistoryPage"
                        :length="Math.ceil(allServiceAccountHistory.length/2)"
                        :total-visible="5"
                      ></v-pagination>
                    </v-flex>
                   
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <!-- Change Requests -->

          <v-flex xs12 sm3 md3 mb-1>
            <v-card class="rounded-card card-outter">
              <v-card-text>
                <h2 class="dark-grey--text">
                  Change Requests
                </h2>
                <v-tabs grow>
                  <v-tab @click="showPendingRequests = true, showResolvedRequests = false">Pending</v-tab>
                  <v-tab @click="showPendingRequests = false, showResolvedRequests = true">Resolved</v-tab>
                </v-tabs>
                <v-container grid-list-xs v-if="showPendingRequests">
                  <v-layout wrap justify-center>
                    <v-flex xs12 sm12 md12 v-for="pending in pendingRequests" :key="pending.id">
                      <v-card hover class="ma-2 pa-2">
                        <v-tile>
                          <v-layout align-center wrap>
                            <v-flex xs12>
                              <h3 class="grey--text">{{pending.requestType}} <v-chip color="blue" class="white--text">{{pending.status}}</v-chip></h3>
                            </v-flex>
                            <v-flex xs8 text-xs-left>
                              <v-tile-title>
                                
                                <div
                                  v-if="(pending.requestType.includes('Upgrade')||pending.requestType.includes('Downgrade'))&&pending.fromSpeedProfile&&pending.toSpeedProfile"
                                >
                                  <h4 class="grey--text">
                                    From:
                                    <v-icon color="light-green">arrow_drop_down</v-icon>
                                    {{pending.fromSpeedProfile.downloadMbps}}
                                    <v-icon color="red">arrow_drop_up</v-icon>
                                    {{pending.fromSpeedProfile.uploadMbps}}
                                  </h4>
                                  <h4 class="grey--text">
                                    To:
                                    <v-icon color="light-green">arrow_drop_down</v-icon>
                                    {{pending.toSpeedProfile.downloadMbps}}
                                    <v-icon color="red">arrow_drop_up</v-icon>
                                    {{pending.toSpeedProfile.uploadMbps}}
                                  </h4>
                                </div>
                                <h4></h4>
                              </v-tile-title>
                              <v-tile-subtitle>
                                <h4
                                  class="grey--text font-weight-light"
                                >Submitted: {{formatDate(pending.createdAt)}}</h4>
                                <h4 class="grey--text font-weight-light">
                                  Submitted by:
                                  <b>{{pending.ispContactName}}</b>
                                </h4>
                              </v-tile-subtitle>
                            </v-flex>
                            <v-flex xs2 text-xs-right>
                              <v-tile-action>
                                <v-layout align-center>
                                  <v-icon large color="light-green" @click="acceptRequestChange(pending)">done</v-icon>
                                  <v-icon large color="red" @click="denyRequestItem(pending)">clear</v-icon>
                                </v-layout>
                              </v-tile-action>
                            </v-flex>
                          </v-layout>
                        </v-tile>
                      </v-card>
                    </v-flex>

                    <v-flex v-if="allPendingRequests.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Pending Requests.</h3>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 class="card-actions" v-if="showPendingRequests && allPendingRequests.length > 1">
                      <v-pagination
                        v-model="pendingRequestPage"
                        :length="Math.ceil(allPendingRequests.length)"
                        :total-visible="5"
                      ></v-pagination>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-container grid-list-xs v-if="showResolvedRequests">
                  <v-layout wrap justify-center>
                    <v-flex xs12 sm12 md12 v-for="resolved in resolvedRequests" :key="resolved.id">
                      <v-card hover class="ma-2">
                        <v-card-text class="pa-2">
                          <v-tile>
                            <v-layout align-center>
                              <v-flex xs12 text-xs-left>
                                <v-tile-title>
                                  <h3 class="title grey--text text-xs-center">
                                    {{resolved.requestType}}
                                    <v-chip
                                      class="white--text"
                                      dense
                                      v-if="resolved.status=='Resolved'"
                                      color="light-green"
                                    >{{resolved.status}}</v-chip>
                                    <v-chip
                                      class="white--text"
                                      dense
                                      v-else
                                      color="red"
                                    >{{resolved.status}}</v-chip>
                                  </h3>

                                  <div
                                    v-if="(resolved.requestType.includes('Upgrade')||resolved.requestType.includes('Downgrade'))&&resolved.fromSpeedProfile&&resolved.toSpeedProfile"
                                  >
                                    <h4 class="grey--text font-weight-light">
                                      <b>From:</b>
                                      <v-icon color="light-green">arrow_drop_down</v-icon>
                                      {{resolved.fromSpeedProfile.downloadMbps}}
                                      <v-icon color="red">arrow_drop_up</v-icon>
                                      {{resolved.fromSpeedProfile.uploadMbps}}
                                    </h4>
                                    <h4 class="grey--text font-weight-light">
                                      <b>To:</b>
                                      <v-icon color="light-green">arrow_drop_down</v-icon>
                                      {{resolved.toSpeedProfile.downloadMbps}}
                                      <v-icon color="red">arrow_drop_up</v-icon>
                                      {{resolved.toSpeedProfile.uploadMbps}}
                                    </h4>
                                  </div>
                                </v-tile-title>
                                <v-tile-subtitle>
                                  <h4 class="grey--text font-weight-light">
                                    <b>Resolved Date:</b>
                                    {{formatDate(resolved.updatedAt)}}
                                  </h4>
                                  <h4 class="grey--text font-weight-light">
                                    <b>Resolved by:</b>
                                    {{resolved.fnoContactName}}
                                  </h4>
                                </v-tile-subtitle>
                              </v-flex>
                            </v-layout>
                          </v-tile>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 class="card-actions" v-if="showResolvedRequests && allResolvedRequests.length > 1">
                      <v-pagination
                        v-model="resolvedRequestPage"
                        :length="Math.ceil(allResolvedRequests.length)"
                        :total-visible="5"
                      ></v-pagination>
                    </v-flex>

                    <v-flex v-if="allResolvedRequests.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Resolved Requests.</h3>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <!-- Device Details -->

          <v-flex xs12 sm5 md5 mb-1>
            <v-card class="rounded-card" heigh="360px">
              <v-card-text>
                <h2 class="dark-grey--text">Device Details</h2>
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-layout justify-center>
                        <v-flex
                          xs6
                          v-if="serviceAccount.device&&serviceAccount.device.deviceMakeModel"
                        >
                          <h2 class="subheading grey--text font-weight-bold">Make & Model :</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3
                            class="grey--text font-weight-light"
                          >{{serviceAccount.device.deviceMakeModel.deviceMake.name}} {{serviceAccount.device.deviceMakeModel.name}}</h3>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center>
                        <v-flex xs6 v-if="serviceAccount.device&&serviceAccount.device.ponMac">
                          <h2 class="subheading grey--text font-weight-bold">PON MAC/FSAN:</h2>
                        </v-flex>
                        <v-flex xs6>
                          <h3 class="grey--text font-weight-light">{{serviceAccount.device.ponMac}}</h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <!-- Active Accounts -->
          <v-flex xs12 sm3 md3 mb-1 mx-1>
            <v-card class="rounded-card" height="360px">
              <v-card-text>
                <h2 class="dark-grey--text">Active Services</h2>
                <v-tabs grow>
                  <v-tab @click="showInternet = true, showWifi = false, showVoip = false">
                    <v-icon>language</v-icon>Internet
                  </v-tab>
                  <v-tab @click="showInternet = false, showWifi = true, showVoip = false" >
                    <v-icon>wifi</v-icon>Wifi
                  </v-tab>
                  <!-- <v-tab @click="showInternet = false, showWifi = false, showVoip = true" >
                    <v-icon>call</v-icon>VOIP
                  </v-tab> -->
                </v-tabs>

                <!-- Internet -->
                <v-container grid-list-xs v-if="showInternet">
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 v-for="internet in internetServices" :key="internet.id">
                      <v-card hover class="ma-2 pa-2">
                        <v-tile>
                          <v-layout align-center >
                            <v-flex xs12>
                              <v-tile-title>
                                <h3 class="grey--text font-weight-light" v-if="internet.access_type">
                                  <b>Access Type:</b> {{internet.access_type}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.access_type == 'PPPOE' ||internet.access_type=='PPPoE'">
                                  <b>PPPOE Username:</b> {{internet.pppoeUsername}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.access_type == 'PPPOE' ||internet.access_type=='PPPoE'">
                                  <b>PPPOE Password:</b> {{internet.pppoePassword}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.vlan">
                                  <b>VLAN:</b> {{internet.vlan}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.downstreamRate">
                                  <b>Download (Mbps):</b> {{internet.downstreamRate}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="internet.upstreamRate">
                                  <b>Upnload (Mbps):</b> {{internet.upstreamRate}}</h3>
                              </v-tile-title>
                              <v-tile-subtitle>
                                <v-layout wrap justify-center align-center>
                                  <v-flex xs12>
                                    <h3 class="grey--text">Ethernet Ports</h3>
                                  </v-flex>
                                  <v-flex xs12>
                                    <v-layout justify-center>
                                      <v-chip class="white--text" color="light-green" v-if="internet.port_1">1</v-chip>
                                      <v-chip class="white--text" color="light-green" v-if="internet.port_2">2</v-chip>
                                      <v-chip class="white--text" color="light-green" v-if="internet.port_3">3</v-chip>
                                      <v-chip class="white--text" color="light-green" v-if="internet.port_4">4</v-chip>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-tile-subtitle>
                            </v-flex>
                          </v-layout>
                        </v-tile>
                      </v-card>
                    </v-flex>
                    <v-flex v-if="showInternet&&internetServices.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Active Internet Services.</h3>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>

                <!-- Wifi -->

                <v-container grid-list-xs v-if="showWifi">
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 v-for="wifi in wifiServices" :key="wifi.id">
                      <v-card hover class="ma-2 pa-2">
                        <v-tile>
                          <v-layout align-center>
                            <v-flex xs12>
                              <v-tile-title>
                                <h3 class="grey--text font-weight-light" v-if="wifi.ssid">
                                  <b>SSID:</b> {{wifi.ssid}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="wifi.password">
                                  <b>Password:</b> {{wifi.password}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="wifi.frequency">
                                  <b>Frequency:</b> {{wifi.frequency}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="wifi.encryption">
                                  <b>Encryption:</b> {{wifi.encryption}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="wifi.enable">
                                  <b>Enabled:</b> {{wifi.enable}}</h3>
                                  <h3 class="grey--text font-weight-light" v-if="wifi.hidden">
                                  <b>Hidden:</b> {{wifi.hidden}}</h3>
                              </v-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-tile>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 v-if="showWifi&&wifiServices.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Active Wifi Services.</h3>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>

                <!-- VOIP -->
                <v-container grid-list-xs v-if="showVoip">
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 v-for="voip in voipServices" :key="voip.id">
                      <v-card hover class="ma-2 pa-2">
                        <v-tile>
                          <v-layout align-center>
                            <v-flex xs8 text-xs-left>
                              <v-tile-title>
                                <h3 class="grey--text">{{voip.id}}</h3>
                              </v-tile-title>
                              <v-tile-subtitle></v-tile-subtitle>
                            </v-flex>
                          </v-layout>
                        </v-tile>
                      </v-card>
                    </v-flex>
                    <v-flex v-if="showVoip&&voipServices.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Active VOIP Services.</h3>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 sm3 md3 mb-1>
            <v-card class="rounded-card" height="360px">
              <v-card-text>
                <h2 class="dark-grey--text">Tickets </h2>
                <v-tabs grow>
                  <v-tab @click="showPendingTickets = true, showResolvedTickets = false">Pending</v-tab>
                  <v-tab @click="showPendingTickets = false, showResolvedTickets = true">Resolved</v-tab>
                </v-tabs>
                <v-container grid-list-xs v-if="showPendingTickets">
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 v-for="pending in pendingTickets" :key="pending.id">
                      <v-card hover >
                        <v-tile>
                          <v-layout align-center>
                            <v-flex >
                              <v-tile-title @click="routeToTicketSummary(pending.id)">
                                 <v-layout>
                            <v-flex xs6 text-xs-left>
                              <h4 class="mx-1 grey--text font-weight-bold">ID:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                               <h4 class=" grey--text font-weight-light">{{pending.id}}</h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6 text-xs-left>
                              <h4 class="mx-1  grey--text font-weight-bold">Category:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                              <h4
                                class="grey--text font-weight-light"
                              >{{pending.ticketCategoryItem.ticketCategory.name}}</h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6 text-xs-left>
                               <h4 class="mx-1 grey--text font-weight-bold">Subcategory:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                             <h4
                                class="grey--text font-weight-light"
                              >{{pending.ticketCategoryItem.name}}</h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center align-center>
                            <v-flex xs6 text-xs-left>
                               <h4 class="mx-1 grey--text font-weight-bold">Status:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                               <h4 class="grey--text">
                                <v-chip
                                  small
                                  :class="`${pending.currentStatus.replace(/\s/g,'').toLowerCase()} white--text`"
                                >{{pending.currentStatus}}</v-chip>
                              </h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6 text-xs-left>
                               <h4 class="mx-1 grey--text font-weight-bold">Assigned To:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                              <h4
                                 v-if="pending.assignedTo !==null"
                                class="grey--text font-weight-light"
                              >{{pending.assignedTo.name}} {{pending.assignedTo.surname}}</h4>
                              <h4 v-else class="grey--text font-weight-light">Unassigned</h4>
                            </v-flex>
                          </v-layout>
                              </v-tile-title>
                              <v-tile-subtitle></v-tile-subtitle>
                            </v-flex>
                          </v-layout>
                        </v-tile>
                      </v-card>
                    </v-flex>

                    <v-flex v-if="showPendingTickets&&allOpenTickets.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Pending Tickets.</h3>
                      </v-layout>
                    </v-flex>
                     <v-flex
                      xs12
                      class="card-actions"
                      v-if="showPendingTickets && allOpenTickets.length > 1"
                    >
                      <v-pagination
                        v-model="pendingTicketPage"
                        :length="Math.ceil(allOpenTickets.length)"
                        :total-visible="5"
                      ></v-pagination>
                    </v-flex>
                  </v-layout>
                </v-container>

                <v-container grid-list-xs v-if="showResolvedTickets">
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 v-for="resolved in resolvedTickets" :key="resolved.id">
                      <v-card hover >
                        <v-card-text>
                          <v-tile>
                            <v-layout align-center>
                              <v-flex >
                                <v-tile-title @click="routeToTicketSummary(resolved.id)">
                                 <v-layout>
                            <v-flex xs6 text-xs-left>
                              <h4 class="mx-1 grey--text font-weight-bold">ID:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                               <h4 class=" grey--text font-weight-light">{{resolved.id}}</h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6 text-xs-left>
                              <h4 class="mx-1  grey--text font-weight-bold">Category:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                              <h4
                                class="grey--text font-weight-light"
                              >{{resolved.ticketCategoryItem.ticketCategory.name}}</h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6 text-xs-left>
                               <h4 class="mx-1 grey--text font-weight-bold">Subcategory:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                             <h4
                                class="grey--text font-weight-light"
                              >{{resolved.ticketCategoryItem.name}}</h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center align-center>
                            <v-flex xs6 text-xs-left>
                               <h4 class="mx-1 grey--text font-weight-bold">Status:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                               <h4 class="grey--text">
                                <v-chip
                                  small
                                  :class="`${resolved.currentStatus.replace(/\s/g,'').toLowerCase()} white--text`"
                                >{{resolved.currentStatus}}</v-chip>
                              </h4>
                            </v-flex>
                          </v-layout>
                          <v-layout justify-center>
                            <v-flex xs6 text-xs-left>
                               <h4 class="mx-1 grey--text font-weight-bold">Assigned To:</h4>
                            </v-flex>
                            <v-flex xs6 text-xs-right>
                              <h4
                                 v-if="resolved.assignedTo !==null"
                                class="grey--text font-weight-light"
                              >{{resolved.assignedTo.name}} {{resolved.assignedTo.surname}}</h4>
                              <h4 v-else class="grey--text font-weight-light">Unassigned</h4>
                            </v-flex>
                          </v-layout>
                              </v-tile-title>
                                <v-tile-subtitle>                                
                                </v-tile-subtitle>
                              </v-flex>
                            </v-layout>
                          </v-tile>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex v-if="showResolvedTickets&&allResolvedTickets.length == 0">
                      <v-layout align-center justify-center>
                        <h3 class="grey--text font-weight-light">No Resolved Tickets.</h3>
                      </v-layout>
                    </v-flex>
                    <v-flex
                      xs12
                      class="card-actions"
                      v-if="showResolvedTickets && allResolvedTickets.length > 1"
                    >
                      <v-pagination
                        v-model="resolvedTicketPage"
                        :length="Math.ceil(allResolvedTickets.length)"
                        :total-visible="5"
                      ></v-pagination>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card> 

   
    <!-- Wifi Dialog -->

    <v-dialog v-model="addWifiProfileItem" max-width="750px" persistent>
      <v-card flat color="white">
        <v-toolbar flat class="primary">
          <h1 class="headline white--text">{{wifiItem.type}} WIFI PROFILE</h1>
        </v-toolbar>
        <v-card-text>
          <v-layout>
            <v-flex xs6 px-1>
              <v-text-field v-model="wifiItem.ssid" label="SSID"></v-text-field>
            </v-flex>
            <v-flex xs6 px-1>
              <v-text-field v-model="wifiItem.password" label="Password"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs6 px-1>
              <v-select
                v-model="wifiItem.encryption"
                label="Encryption Type"
                :items="encryptionTypes"
              ></v-select>
            </v-flex>
            <v-flex xs6 px-1>
              <v-select
                v-model="wifiItem.frequencyBand"
                label="Frequency Band"
                :items="availableFrequency"
              ></v-select>
            </v-flex>
          </v-layout>
         
          <v-layout>
             <v-flex xs4 px-4>
            <v-text-field v-model="wifiItem.channel" label="Channel" type="number"></v-text-field>
          </v-flex>
            <v-flex xs3 ml-1 px-1>
              <v-switch v-model="wifiItem.enable" label="Enabled"></v-switch>
            </v-flex>
            <v-flex xs3 px-1>
              <v-switch v-model="wifiItem.hidden" label="Hidden"></v-switch>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              class="primary white--text"
              round
              @click="addWifiProfileItem=false, wifiItem={}"
            >Cancel</v-btn>
            <v-btn class="primary white--text" round @click="saveWifiProfile()">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

export default {
  components: {
    VueCtkDateTimePicker: VueCtkDateTimePicker
  },
  data() {
    return {
      dateTimeSelect:false,
      addTemplate:false,
      addCommentBox: false,
      statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
      importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
      ticketItem: {},
      ticketCategories:[],
      ticketCategoryItems:[],
      filteredCategoryItems: [],
      filteredUsers: [],
      ticketAssignedLog: [],
      ticketCommentLog: [],
      filteredTickets: {},
      ticketTemplates: [],
      userRoles:[],     
      addTicketModal: false,
      addWifiProfileItem: false,
      allOpenTickets: [],
      allPendingRequests: [],
      allIspPackages: [],
      allResolvedRequests: [],
      allResolvedTickets: [],
      allServiceAccountHistory: [],
      availableFrequency: [],
      changeRequestItem: {},
      changeRequestModal: false,
      denyItem: {},
      denyReason: '',
      denyRequestModal: false,
      encryptionTypes: ["WEP", "WPA", "WPA2", "WPA+WPA2"],
      errorSnackbar: false,
      internetServices: [],
      pendingRequests: [],
      pendingTickets: [],
      pendingRequestPage: 1,
      pendingTicketPage: 1,
      resolvedRequests: [],
      resolvedTickets: [],
      resolvedRequestPage: 1,
      resolvedTicketPage: 1,
      selectablePackages: [],
      serviceAccount: null,
      serviceAccountHistory: [],
      serviceAccountHistoryPage: 1,
      showInternet: true,
      showWifi: false,
      showVoip: false,
      showPendingRequests: true,
      showResolvedRequests: false,
      showPendingTickets: true,
      showResolvedTickets: false,
      snackbar: false,
      text: '',
      today: new Date().toISOString().substr(0, 10),
      top: "y",
      wifiItem: {},
      wifiServices: [],
      voipServices: []
    };
  },
  watch: {
    "ticketItem.ticketTemplateId": {
      immediate: true,
      async handler(value) {
        if (value === null && this.ticketItem.ticketCategoryId != null) {
          Api()
            .get(
              "/ticketCategoryItem/byCategory/" +
                this.ticketItem.ticketCategoryId
            )
            .then(response => {
              for (let k = 0; k < response.length; k++) {
                this.filteredCategoryItems = response.data[k];
              }
            });
        }
      }
    },
    "ticketItem.userRoleId":{
       immediate: true,
      async handler(value) {
        if (value && value !== null) {
          Api().get('/userRoleContact/byUserRole/'+ value).then(response=>{
            this.filteredUsers = response.data.map(x=>x.contact)
          })
        }
      }
    },
    "ticketItem.ticketCategoryId": {
      immediate: true,
      async handler(value) {
        if (value && value !== null) {
          this.filteredCategoryItems = await this.ticketCategoryItems.filter(
            function(el) {
              return el.ticketCategoryId === value;
            }
          );
        } else {
          this.filteredCategoryItems = this.ticketCategoryItems;
        }
      }
    },
    "ticketItem.assignedToId": {
      immediate: true,
      handler(value) {
        
        if (this.editTicketModal && value !== this.initialAssignedId) {
          if (
            this.ticketItem.id &&
            value !== null &&
            typeof value !== "undefined"
          ) {
            Api()
              .post("/ticketAssignLog", {
                ticketId: this.ticketItem.id,
                assignedToId: this.ticketItem.assignedToId
              })
              .then(response => {
                let find = this.users.find(x => x.id === value);
                response.data.assignedTo = find;
                response.data.assignedBy = this.$store.state.user;
                this.ticketAssignedLog.push(response.data);
              });
            Api().put("/ticket/" + this.ticketItem.id, {
              assignedToId: this.ticketItem.assignedToId
            });
          }
        }
      }
    },
       resolvedTicketPage(value) {
      this.resolvedTickets = this.allResolvedTickets.slice(value - 1, value);
    },
    pendingTicketPage(value) {
      this.pendingTickets = this.allOpenTickets.slice(value - 1, value);
    },
    resolvedRequestPage(value) {
      this.resolvedRequests = this.allResolvedRequests.slice(value - 1, value);
    },
    pendingRequestPage(value) {
      this.pendingRequests = this.allPendingRequests.slice(value - 1, value);
    },
    serviceAccountHistoryPage(value){
      if(value==1){
      this.serviceAccountHistory = this.allServiceAccountHistory.slice(0, 2);

      } else {
      this.serviceAccountHistory = this.allServiceAccountHistory.slice(value*2 - 2, value*2);

      }
    },
    "changeRequestItem.requestType": {
      immediate: true,
      handler(value) {
        if (value == "Upgrade") {
          this.selectablePackages = this.allIspPackages.filter(x => {
            return (
              x.locationNetworkId ===
                this.serviceAccount.location.locationNetworkId &&
              x.packagesFno.speedProfile.downloadMbps >=
                this.serviceAccount.packagesIsp.packagesFno.speedProfile
                  .downloadMbps &&
              x.packagesFno.speedProfile.uploadMbps >
                this.serviceAccount.packagesIsp.packagesFno.speedProfile
                  .uploadMbps
            );
          });
        } else if (value == "Downgrade") {
          this.selectablePackages = this.allIspPackages.filter(x => {
            return (
              x.locationNetworkId ===
                this.serviceAccount.location.locationNetworkId &&
              x.packagesFno.speedProfile.downloadMbps <=
                this.serviceAccount.packagesIsp.packagesFno.speedProfile
                  .downloadMbps &&
              x.packagesFno.speedProfile.uploadMbps <
                this.serviceAccount.packagesIsp.packagesFno.speedProfile
                  .uploadMbps
            );
          });
        }
      }
    }
  },
  async created() {
    await this.getServiceAccountDetails();
    this.getInternetProfiles()
    this.getChangeRequests();
    this.getServiceAccountHistory();
    this.getActiveISPPackages();
    this.getTickets()  
    this.fetchOrgContacts();
    this.fetchUserRoles()
    this.fetchTicketCategories();
    this.fetchTicketCategoryItems();
    this.fetchTicketTemplates();
  },
  methods: {
      clearTemplate() {
      this.ticketItem.dueDate = "";
      this.ticketItem.dueTime = "";
      this.ticketItem.assignedToId = null;
      this.ticketItem.ticketCategoryItemId = null;
      this.ticketItem.ticketCategoryId = null;
    },
    populateTemplate() {
      this.clearTemplate();
      for (let i = 0; i < this.ticketTemplates.length; i++) {
        if (this.ticketTemplates[i].id === this.ticketItem.ticketTemplateId) {
          this.ticketItem.dueDate = this.ticketTemplates[i].dueDate;
          this.ticketItem.dueTime = this.ticketTemplates[i].dueTime;
          this.ticketItem.assignedToId = this.ticketTemplates[i].contactId;
          if (this.ticketTemplates[i].ticketCategoryItem !== null) {
            this.ticketItem.ticketCategoryItemId = this.ticketTemplates[
              i
            ].ticketCategoryItemId;
            this.ticketItem.ticketCategoryId = this.ticketTemplates[
              i
            ].ticketCategoryItem.ticketCategoryId;
          }
        }
      }
    },
    fetchUserRoles(){
      Api()
      .get('/userRole')
      .then(response=>{
        this.userRoles=response.data
      })
    },
    addTicket(date) {
      if (date == null) {
        this.addTicketModal = true;
        this.ticketItem = {
          importance: "Normal",
          currentStatus: "Pending",
          dueDate: this.formatDate(new Date())
        };
      } else {
        this.ticketItem = {
          importance: "Normal",
          currentStatus: "Pending",
          dueDate: this.formatDate(new Date(date))
        };
        this.addTicketModal = true;
      }
    },
      fetchTicketCategories() {
      Api()
        .get("/ticketCategory")
        .then(response => {
          this.ticketCategories = response.data;
        });
    },
     fetchTicketCategoryItems() {
      Api()
        .get("/ticketCategoryItem")
        .then(response => {
          this.ticketCategoryItems = response.data;
        });
    },
    async createNewTicket() {
      this.ticketItem.serviceAccountId= this.$route.params.serviceAccountId
      await Api()
        .post("/ticket", this.ticketItem)
        .then(response => {
          this.key++
          if (this.ticketCommentLog.length > 0) {
            for (let i = 0; i < this.ticketCommentLog.length; i++) {
              this.ticketCommentLog[i].ticketId = response.data.id;
            }
            Api()
              .post("/ticketComment", {
                batch: this.ticketCommentLog
              })
              .then(response => {});
          }
          if (this.ticketItem.assignedToId) {
            Api().post("/ticketAssignLog", {
              assignedToId: this.ticketItem.assignedToId,
              assignedById: this.$store.state.user.id,
              ticketId: response.data.id
            });
          }
          this.getTickets()  
      this.addTicketModal = false;
      this.ticketItem = {};
        })
    },
     fetchOrgContacts() {
      this.filteredUsers = [];
      Api()
        .get("/organisationContact")
        .then(async response => {
          this.filteredUsers = response.data.filter(function(el) {
            return el.userType !== "endClient";
          });
          let contactArray = await this.filteredUsers.map(x => x.contact);
          this.filteredUsers = contactArray;
        });
    },
      addComment(comment) {
      this.ticketCommentLog.push({
        commentedBy: this.$store.state.user,
        commentedById: this.$store.state.user.id,
        comment: comment,
        type: "comment",
        createdAt: new Date()
      });
      this.comment = "";
      this.addCommentBox = false;
    },
     fetchTicketTemplates() {
      Api()
        .get("/ticketTemplate")
        .then(response => {
          this.ticketTemplates = response.data;
        });
    },    
    async routeToTicketSummary(item){
     let url =item
      let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
        return el.url === '/ticketSummary/:ticketId'})
      await this.$store.dispatch('setCurrentRoute', route[0])
      this.$router.push({ path: "/ticketSummary/" + item });
    },
    addWifiProfileModal() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        this.wifiItem = {
          type: "ADD",
          ssid: "",
          password: "",
          channel: 0,
          encryption: "WPA2",
          enable: true,
          hidden: false,
          frequencyBand: this.availableFrequency[0],
          deviceBridgeId: this.serviceAccount.deviceBridgeId,
          customerOrganisationId: this.serviceAccount.customerOrganisationId
        };
        this.addWifiProfileItem = true;
      }
    },
    denyRequestItem(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      this.denyItem = Object.assign({}, item);
      this.denyRequestModal = true;
      }
    },
    async getActiveISPPackages() {
      await Api()
        .get(
          "/supplier/packagesIsps/networkCustomer/active/" +
            this.serviceAccount.location.locationNetworkId +
            "/" +
            this.serviceAccount.customerOrganisationId
        )
        .then(response => {
          this.allIspPackages = response.data;
        });
    },
    async getServiceAccountDetails() {
      await Api()
        .get("/serviceAccounts/" + this.$route.params.serviceAccountId)
        .then(response => {
          this.serviceAccount = response.data;
        });
    },
    async getServiceAccountHistory() {
      await Api()
        .get(
          "/serviceAccounts/allByIdentifier/" +
            this.serviceAccount.serviceAccountIdentifier
        )
        .then(response => {
          this.allServiceAccountHistory = response.data
          this.serviceAccountHistory = this.allServiceAccountHistory.slice(0,2);
        });
    },
    async getChangeRequests() {
      await Api()
        .get(
          "/serviceAccountsAuditLog/byServiceAccountId/" +
            this.$route.params.serviceAccountId
        )
        .then(response => {
          this.allPendingRequests = response.data.filter(
            x => x.status != "Denied" && x.status != "Resolved"
          );
          this.pendingRequests = this.allPendingRequests.slice(0,1);

          this.allResolvedRequests = response.data.filter(
            x => x.status == "Denied" || x.status == "Resolved"
          );
          this.resolvedRequests = this.allResolvedRequests.slice(0,1);
        });
    },
    async getInternetProfiles(){
      await Api()
        .get("/deviceBridge/byBridge/" + this.serviceAccount.deviceBridgeId)
        .then(response => {
          this.internetServices = response.data;
          this.wifiServices = response.data.deviceWifis || []
          this.voipServices = response.data.deviceVoips || []
          if((this.wifiServices.length==0&&this.serviceAccount.device.deviceMakeModel.twoGhzWifi) ||(this.serviceAccount.device.deviceMakeModel.twoGhzWifi&& !this.wifiServices.map(x=>x.frequency).includes('2.4'))){
            this.availableFrequency.push('2.4')
          }
          if((this.wifiServices.length==0&&this.serviceAccount.device.deviceMakeModel.fiveGhzWifi)||(this.serviceAccount.device.deviceMakeModel.fiveGhzWifi && !this.wifiServices.map(x=>x.frequency).includes('5'))){
            this.availableFrequency.push('5')
          }
        });
    },
    async getTickets(){
      await Api().get('/ticket/byServiceAccount/'+this.$route.params.serviceAccountId)
      .then(response=>{
        this.allOpenTickets=response.data.filter(x=>!x.isComplete)
        this.allResolvedTickets=response.data.filter(x=>x.isComplete)
        this.pendingTickets = this.allOpenTickets.slice(0, 1);
        this.resolvedTickets = this.allResolvedTickets.slice(0, 1);
      })
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    logServiceAccountChange(item) {
      let toSpeedId = null;
      let toSpeedName = null;
      let toPackageId = null;
      if (
        item.requestType !== "Termination" &&
        item.requestType !== "Migration" &&
        item.toPackage
      ) {
        toSpeedId = item.toPackage.packagesFno.speedProfileId;
        toSpeedName =
          item.toPackage.packagesFno.speedProfile.downloadMbps +
          "/" +
          item.toPackage.packagesFno.speedProfile.uploadMbps;
        toPackageId = item.toPackage.id;
      }

      let obj = {
        status: "Pending",
        serviceAccountId: this.$route.params.serviceAccountId,
        serviceAccountIdentifier: this.serviceAccount.serviceAccountIdentifier,
        locationId: this.serviceAccount.locationId,
        migrationLocationId: this.migrationLocationId || null,
        packagesIspId: this.serviceAccount.packagesIspId,
        locationDescription: this.serviceAccount.location.locationDescription,
        customerOrganisationId: this.serviceAccount.packagesIsp
          .customerOrganisationId,
        ispName: this.serviceAccount.customerOrganisation.name,
        requestType: item.requestType,
        isChange: this.serviceAccount.isChange,
        ispNotification: true,
        fnoNotification: true,
        ispContactName: null,
        fnoContactName:
          this.$store.state.user.name + " " + this.$store.state.user.surname,
        fromSpeedProfileName:
          this.serviceAccount.packagesIsp.packagesFno.speedProfile
            .downloadMbps +
          "/" +
          this.serviceAccount.packagesIsp.packagesFno.speedProfile.uploadMbps,
        fromSpeedProfileId: this.serviceAccount.packagesIsp.packagesFno
          .speedProfileId,
        toSpeedProfileId: toSpeedId,
        toSpeedProfileName: toSpeedName,
        toPackageId: toPackageId,
        authenticationType: this.serviceAccount.authenticationType,
        pppoeUsername: this.serviceAccount.pppoeUsername || null,
        pppoePassword: this.serviceAccount.pppoePassword || null,
        IPoEMacAddress: this.serviceAccount.IPoEMacAddress || null,
        initialActivation: this.serviceAccount.initialActivation
          ? new Date(this.serviceAccount.initialActivation)
              .toISOString()
              .substr(0, 10)
          : null,
        fnoActivationDate: this.serviceAccount.fnoActivationDate
          ? new Date(this.serviceAccount.fnoActivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        fnoDeactivationDate: this.serviceAccount.fnoDeactivationDate
          ? new Date(this.serviceAccount.fnoDeactivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        ispActivationDate: this.serviceAccount.ispActivationDate
          ? new Date(this.serviceAccount.ispActivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        ispDeactivationDate: this.serviceAccount.ispDeactivationDate
          ? new Date(this.serviceAccount.ispDeactivationDate)
              .toISOString()
              .substr(0, 10)
          : null,
        requestedChangeDate: item.requestedChangeDate,
        staticIpv4: this.serviceAccount.staticIpv4 || null,
        staticIpv6: this.serviceAccount.staticIpv6 || null,
        deviceId: this.serviceAccount.deviceId,
        deviceBridgeId: this.serviceAccount.deviceBridgeId,
        isDeleted: false,
        isActive: true
      };
      console.log(obj)
      Api()
        .post("/serviceAccountsAuditLog", obj)
        .then(async response => {
          obj.serviceAccountAuditLogId = response.data.id;
          await this.acceptFNOChange(obj);
          this.changeRequestModal = false;
          this.changeRequestItem = {};
        });
    },
    async acceptFNOChange(item) {
      let newServiceAccountId = null;
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (item.requestType !== "Termination") {
          let locationId = null;
          let deviceId = null;
          if (item.requestType !== "Migration") {
            locationId = item.locationId;
            deviceId = item.deviceId;
          } else {
            locationId = item.migrationLocationId;
            deviceId = null;
          }

          Api().put("/serviceAccounts/" + this.$route.params.serviceAccountId, {
            ispDeactivationDate: item.requestedChangeDate,
            fnoDeactivationDate: item.requestedChangeDate
          });
          if (
            item.authenticationType === "PPPoE" ||
            item.authenticationType === "PPPOE"
          ) {
            item.IPoEActive = null;
          } else {
            item.IPoEActive = true;
          }

          let newAccount = {
            serviceAccountIdentifier: item.serviceAccountIdentifier.toString(),
              authenticationType: item.authenticationType,
              pppoeUsername: item.pppoeUsername || null,
              pppoePassword: item.pppoePassword || null,
              IPoEMacAddress: item.IPoEMacAddress,
              initialActivation: item.initialActivation,
              fnoActivationDate: item.requestedChangeDate || null,
              fnoDeactivationDate: null,
              ispActivationDate: item.requestedChangeDate || null,
              ispDeactivationDate: null,
              staticIpv4: item.staticIpv4 || null,
              staticIpv6: item.staticIpv6 || null,
              isChange: true,
              locationId: locationId,
              deviceId: deviceId,
              packagesIspId: item.toPackageId || item.packagesIspId,
              // vlanId: item.vlan.id,
              customerOrganisationId: item.customerOrganisationId,
              deviceBridgeId: item.deviceBridgeId,
              innerVlan: item.innerVlan,
              outerVlan: item.outerVlan,
              IPoEActive: item.IPoEActive,
              isDeleted: false,
              isActive: true
          }

          await Api()
            .post("/serviceAccounts", newAccount)
            .then(response => {
              newServiceAccountId = response.data.id;
            });
        } else {
          Api().put("/serviceaccounts/" + this.$route.params.serviceAccountId, {
            fnoDeactivationDate: item.requestedChangeDate,
            ispDeactivationDate: item.requestedChangeDate
          });
        }
        let uploadMbps = 0;
        let downloadMbps = 0;
        if (item.toPackage && item.toPackage != null) {
          uploadMbps = item.toPackage.packagesFno.speedProfile.uploadMbps;
          downloadMbps = item.toPackage.packagesFno.speedProfile.downloadMbps;
        }
        let autoProvision = false;
        let autoProvisionType = null;
        if (
          this.serviceAccount.device &&
          this.serviceAccount.device != null &&
          this.serviceAccount.device.Handle_ID != null &&
          !this.serviceAccount.device.acsDevice
        ) {
          autoProvision = true;
          autoProvisionType = "Zhone";
        } else if (
          this.serviceAccount.device &&
          this.serviceAccount.device != null &&
          this.serviceAccount.device.acsDevice
        ) {
          autoProvision = true;
          autoProvisionType = "ACS";
        }
        // debugger
        Api()
          .put("/serviceAccountsAuditLog/" + item.serviceAccountAuditLogId, {
            autoProvision: autoProvision,
            autoProvisionType: autoProvisionType,
            ponMac: this.serviceAccount.device.ponMac,
            customerOrganisationId: item.customerOrganisationId,
            fnoContactName:
              this.$store.state.user.name +
              " " +
              this.$store.state.user.surname,
            requestedChangeDate: item.requestedChangeDate,
            deviceId: item.deviceId,
            requestType: item.requestType,
            serviceAccountId: newServiceAccountId || this.serviceAccount.id,
            connectionId: item.deviceBridge ? item.deviceBridge.connectionId : null,
            deviceBridgeId: item.deviceBridgeId,
            uploadMbps: uploadMbps,
            downloadMbps: downloadMbps,
            isActive: false,
            status: "Resolved",
            dateResolved: new Date()
          })
          .then(response => {
            // debugger
            console.log(response.data)
            this.getChangeRequests();
          });
      }
    },
    acceptRequestChange(item) {
      console.log(item)
      debugger
      if(this.authUpdate(this.$store.state.currentRoute)){
        let newServiceAccountId = null;
      if (item.requestType !== "Termination") {
        let locationId = null;
        let deviceId = null;
        if (item.requestType === "Migration") {
          locationId = item.migrationLocationId;
          deviceId = null;
        } else {
          locationId = item.locationId;
          deviceId = item.deviceId;
        }
        Api().put("/serviceAccounts/" + item.serviceAccountId, {
          ispDeactivationDate: item.requestedChangeDate,
          fnoDeactivationDate: item.requestedChangeDate
        });
        if (item.authenticationType === "PPPoE") {
          item.IPoEActive = null;
        } else {
          item.IPoEActive = true;
        }
        // let packagesIspId = null;
        // if (item.toSpeedProfileId === null) {
        //   packagesIspId = item.packagesIspId;
        // } else {
        //   packagesIspId = item.toPackageId;
        // }
          Api().post("/serviceAccounts", {
            serviceAccountIdentifier: item.serviceAccountIdentifier.toString(),
            authenticationType: item.authenticationType,
            pppoeUsername: item.pppoeUsername || null,
            pppoePassword: item.pppoePassword || null,
            IPoEMacAddress: item.IPoEMacAddress,
            initialActivation: item.initialActivation,
            fnoActivationDate: item.requestedChangeDate || null,
            fnoDeactivationDate: null,
            ispActivationDate: item.requestedChangeDate || null,
            ispDeactivationDate: null,
            staticIpv4: item.staticIpv4 || null,
            staticIpv6: item.staticIpv6 || null,
            isChange: true,
            locationId: locationId,
            customerOrganisationId: item.customerOrganisationId,
            deviceId: deviceId,
            packagesIspId: item.toPackageId || item.packagesIspId,
            vlanId: item.vlanId,
            IPoEActive: item.IPoEActive,
            isDeleted: false,
            isActive: true
          }).then(response=>{
            newServiceAccountId = response.data.id
          });
      } else {
        Api().put("/serviceaccounts/" + item.serviceAccountId, {
          fnoDeactivationDate: item.requestedChangeDate,
          ispDeactivationDate: item.requestedChangeDate
        });
      }

      let autoProvision = false
        let autoProvisionType = null
        if(item.device&&item.device!=null&&item.device.Handle_ID != null&&!item.device.acsDevice){
          autoProvision=true
          autoProvisionType='Zhone'
        } else if(item.device&&item.device!=null&&item.device.acsDevice){
          autoProvision=true
          autoProvisionType='ACS'
        }

       let bridge = null
      if(item.serviceAccount.deviceBridge){
        bridge = item.serviceAccount.deviceBridge.connectionId
      }
      
        let uploadMbps = 0
      let downloadMbps =0
      if(item.toSpeedProfile&&item.toSpeedProfile!=null){
        uploadMbps = item.toSpeedProfile.uploadMbps
        downloadMbps = item.toSpeedProfile.downloadMbps
      }
      Api()
        .put("/serviceAccountsAuditLog/" + item.id, {
          autoProvision: autoProvision,
          autoProvisionType: autoProvisionType,
          ponMac: this.serviceAccount.device.ponMac,
          customerOrganisationId: item.customerOrganisationId,
          fnoContactName:
            this.$store.state.user.name + " " + this.$store.state.user.surname,
            requestedChangeDate: item.requestedChangeDate,
            deviceId: this.serviceAccount.deviceId,
            requestType: item.requestType,
            serviceAccountId: newServiceAccountId || this.$route.params.serviceAccountId,
            connectionId: bridge,
            deviceBridgeId: this.serviceAccount.deviceBridgeId,
            deviceBridge: this.serviceAccount.deviceBridge,
            uploadMbps: uploadMbps,
            downloadMbps: downloadMbps,
          isActive: false,
          status: "Resolved",
          dateResolved: new Date()
          }).then(()=>{
            this.getChangeRequests()
          });
      }
    },
    denyRequestChange(item) {
      if(this.authUpdate(this.$store.state.currentRoute)){
      Api()
        .put("/serviceAccountsAuditLog/" + item.id, {
          serviceAccountId: this.$route.params.serviceAccountId,
          fnoContactName: this.$store.state.user.name + " " + this.$store.state.user.surname,
          comment: this.denyReason,
          isActive: false,          
          customerOrganisationId: item.customerOrganisationId,
          status: "Denied"
        })
        .then(()=>{
          this.getChangeRequests()
          this.denyRequestModal=false
          this.denyReason = ''
        });
      }
    },
    async saveWifiProfile() {
      if (this.wifiItem.type === "ADD") {
        await Api()
          .post("/acs/createWifi", {
            ssid: this.wifiItem.ssid,
            password: this.wifiItem.password,
            channel: this.wifiItem.channel,
            encryption: this.wifiItem.encryption,
            enable: this.wifiItem.enable,
            hidden: this.wifiItem.hidden,
            frequency: this.wifiItem.frequencyBand,
            ponMac: this.serviceAccount.device.ponMac,
            customerOrganisationId: this.wifiItem.customerOrganisationId
          })
          .then(async response => {
              if(response.data.code===200){
                  await Api()
              .post("/deviceWifi", {
                ssid: this.wifiItem.ssid,
                password: this.wifiItem.password,
                channel: this.wifiItem.channel,
                encryption: this.wifiItem.encryption,
                enable: this.wifiItem.enable,
                hidden: this.wifiItem.hidden,
                frequencyBand: this.wifiItem.frequencyBand,
                deviceId: this.serviceAccount.deviceId,
                deviceBridgeId: this.serviceAccount.deviceBridgeId,
                customerOrganisationId: this.wifiItem.customerOrganisationId,
                isActive: true,
                isDeleted: false
              })
              .then(response => {
                this.wifiServices.push(response.data);
                this.snackbar = true
                this.text = response.data.message
              });
              } else {
                  this.errorSnackbar = true
                  this.text = response.data.message
              }
            this.wifiItem = {};
            this.addWifiProfileItem = false;
            let index = this.availableFrequency.find(x=>x==this.wifiItem.frequency)
            this.availableFrequency.splice(index, 1)
          });
      } else if (this.item.type === "EDIT") {
          await Api()
          .post("/acs/updateWifi", {
            ssid: this.wifiItem.ssid,
            password: this.wifiItem.password,
            channel: this.wifiItem.channel,
            encryption: this.wifiItem.encryption,
            enable: this.wifiItem.enable,
            hidden: this.wifiItem.hidden,
            frequency: this.wifiItem.frequencyBand,
            ponMac: this.device.ponMac,
            customerOrganisationId: this.item.customerOrganisationId
          }).then(response=>{
              Api()
          .put("/deviceWifi/" + this.wifiItem.id, {
            ssid: this.wifiItem.ssid,
            password: this.wifiItem.password,
            channel: this.wifiItem.channel,
            encryption: this.wifiItem.encryption,
            enable: this.wifiItem.enable,
            hidden: this.wifiItem.hidden,
            frequencyBand: this.wifiItem.frequencyBand,
            isActive: true,
            isDeleted: false
          })
          .then(async response => {
              let find = await this.item.deviceWifis.find(x=>x.id===this.wifiItem.id)
              if(find){
                  let index = this.item.deviceWifis.indexOf(find)
                  this.item.deviceWifis[index] = response.data
              }
            this.wifiItem = {};
            this.wifiKey += 1
            this.addWifiProfileItem = false;
          });
          })
        
      }
    },
  }
};
</script>
<style scoped>
.card-outter {
  position: relative;
  padding-bottom: 50px;
}
.card-actions {
  position: absolute;
  bottom: 0;
  align-content: "center";
  justify-content: "center";
}
</style>